import { HttpInterceptorFn } from '@angular/common/http';

import { APP_CONSTANTS } from '../constants/app.constants';
import { isPublicLeaderboardApiUrl } from '../utils/public-leaderboard.utils';
import { isJwtExpiredStrict } from '../utils/jwt.utils';

export const bearerTokenInterceptor: HttpInterceptorFn = (req, next) => {
  // Public kiosk APIs must not send cookies or a stale JWT — expired tokens on TV
  // browsers often surface as HTTP status 0 (CORS/opaque failure) after a few minutes.
  if (isPublicLeaderboardApiUrl(req.url)) {
    return next(req.clone({ withCredentials: false }));
  }

  const accessToken = localStorage.getItem(APP_CONSTANTS.STORAGE_KEYS.AUTH_TOKEN);
  const validToken =
    accessToken && !isJwtExpiredStrict(accessToken) ? accessToken : null;

  const request = req.clone({
    withCredentials: true,
    setHeaders: {
      [APP_CONSTANTS.CLIENT_PLATFORM_HEADER]: APP_CONSTANTS.CLIENT_PLATFORM,
      ...(validToken ? { Authorization: `Bearer ${validToken}` } : {})
    }
  });

  return next(request);
};
